import React, { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux'
import axios from 'axios';
import { GET_LOCATION_USER } from '../../constants';
// import { user_details } from '../../store/user-slice'


const Navbar = (props) => {
  const history = useHistory();
  const [data, setData] = useState([])
  // const dispatch = useDispatch()
  // const user =useSelector((state) => state.details)




  useEffect(()=>{

    getLocation() 


  },[])

  const getLocation = async () => {
    let formData = new FormData()
    formData.append('user_id', localStorage.getItem('access_token'))
    const response = await axios.post(GET_LOCATION_USER, formData);
    console.log(response)
    if (response.data.status === 'success') {
        const data = response.data.data.map(item => {
            return { 'label': item.location, 'value': item.location }
        })
        setData(data)
    }
}
  // const getVesselsDetails = async ()=>{

  //     const response = await API.get(VESSEL_WITH_ID_URL(props.user.vesselId));
  //     if (response.status === 200) {

  //       setData(response.data)
  //     }

  // }
  const toggleOffcanvas = () => {
    document.querySelector('.sidebar-offcanvas').classList.toggle('active');
  }
  const getlogout = () => {
    localStorage.removeItem('access_token');
    history.push('/login')
  }
  return (
    <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
      <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
        <button className="navbar-toggler navbar-toggler align-self-center" type="button" onClick={() => document.body.classList.toggle('sidebar-icon-only')}>
          <span className="icon-menu"></span>
        </button>
        <Link className="navbar-brand brand-logo" to="/"><img
          // @ts-ignore
          src={require("../../assets/images/brand-logo.png")} className="me-2" alt="logo" /></Link>
        <Link className="navbar-brand brand-logo-mini" to="/"><img
          // @ts-ignore
          src={require('../../assets/images/brand-logo.png')} alt="logo" /></Link>
      </div>
      <div className="navbar-menu-wrapper d-flex align-items-stretch justify-content-end">
        <ul className="navbar-nav">
          <li className="nav-item font-weight-semibold d-none d-lg-block ms-0">

            <h1 className="welcome-text">Hello <b style={{ color: '#000' }}>{localStorage.getItem('name')}</b></h1>
            <p>Training Coordinator for <b>{data.map(item =>{return item.label +' , '})}</b></p>

            {/* <h3 className="welcome-sub-text">Here is your live MIDAS Dashboard </h3> */}
          </li>

        </ul>
        {/* <div style={{paddingLeft:'20%'}}> </div> */}


        <ul className="navbar-nav navbar-nav-right">
          <li>
            <img
              // @ts-ignore
              src={require("../../assets/images/logok.png")} className="me-2" alt="logo" style={{ height: 80 }} />
          </li>

          {/* <li className="nav-item">
            <form className="search-form" action="#">
              <i className="icon-search"></i>
              <input type="search" className="form-control" placeholder="Search Here" title="Search here" />
            </form>
          </li> */}


          <li className="nav-item">
            <i className='mdi mdi-exit-to-app fa-4x' onClick={getlogout}></i>
          </li>

        </ul>
        <button className="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" onClick={toggleOffcanvas}>
          <span className="icon-menu"></span>
        </button>
      </div>
    </nav>
  );

}

export default Navbar;
